import Title from '@cohort/components-xps/components/Title';
import Switch from '@cohort/shared-frontend/components/Switch';
import {cn} from '@cohort/shared-frontend/utils/classNames';
import notify from '@cohort/wallet/components/toasts/Toast';
import {useCohortMutation} from '@cohort/wallet/hooks/api/Query';
import {userKeys} from '@cohort/wallet/hooks/api/User';
import {useApi} from '@cohort/wallet/hooks/useApi';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {UserApi} from '@cohort/wallet/lib/Endpoints';
import type {UserWDto} from '@cohort/wallet-schemas/user';
import {useQueryClient} from '@tanstack/react-query';
import {useTranslation} from 'react-i18next';

type NotificationsOptionProps = {
  user: UserWDto;
};

const NotificationsOptin: React.FC<NotificationsOptionProps> = ({user}) => {
  const {t} = useTranslation('pages', {keyPrefix: 'space.settingsPage.notificationsOptin'});
  const {hasDarkBg, backgroundColor, accentColor} = useThemeContext();
  const patchUser = useApi(UserApi.patchUser);
  const queryClient = useQueryClient();
  const {mutate: updateUser} = useCohortMutation({
    mutationFn: patchUser,
    onSuccess: () => {
      queryClient.invalidateQueries(userKeys.user);
      notify('success', t('successfullUpdate'));
    },
  });

  return (
    <div className="flex justify-between">
      <div>
        <Title content={t('title')} classes="text-lg" />
        <p className={cn('text-sm font-medium', hasDarkBg ? 'text-white/60' : 'text-black/60')}>
          {t('description')}
        </p>
      </div>
      <div>
        <Switch
          customTheme={{backgroundColor, accentColor, hasDarkBg}}
          checked={user.notificationsEnabled}
          onClick={() => {
            updateUser({notificationsEnabled: !user.notificationsEnabled});
          }}
        />
      </div>
    </div>
  );
};

export default NotificationsOptin;
